module.exports = __webpack_public_path__ + "static/17-fc3482055ff6b81a1b087a04637a8c8d.png";